
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerEditor()
    export class IcStockCountCodeEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, IcStockCountCodeRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return IcStockCountCodeRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
